import * as Sentry from '@sentry/react';
import { MotionConfig } from 'framer-motion';
import { RouterProvider, type RouterProviderProps } from 'react-router-dom';

import { Toaster, TooltipProvider } from '@/app/shared/ui';
import { TenkoToaster } from '@/shared/components/feedback/TenkoToast';
import { TenkoTooltipProvider } from '@/shared/components/overlays/TenkoTooltip';

import { AppErrorFallback } from './AppErrorFallback';

interface AppRootProps {
  router: RouterProviderProps['router'];
}

/** Visual root shared by every dashboard: base surface, motion, tooltips, toasters. */
export function AppRoot({ router }: AppRootProps) {
  return (
    <div
      className={`body-font font-inter w-full min-h-screen
        bg-[var(--tk-surface-bg)] text-[var(--tk-surface-fg)]
        accent-[var(--tk-brand-bg)]
        selection:bg-tk-brand-500/70 selection:text-white
        dark:selection:bg-tk-brand-500/60`}
    >
      {/* `reducedMotion="user"` honors the OS-level prefers-reduced-motion
          setting: animations collapse to instant transitions automatically
          for users who opted out. */}
      <MotionConfig reducedMotion="user">
        <TooltipProvider delayDuration={200}>
          <TenkoTooltipProvider delay={200}>
            {/* Wraps the router, not the whole tree: a render that throws
                leaves the toasters mounted and the fallback still has theme
                and translations from the providers above. */}
            <Sentry.ErrorBoundary
              fallback={({ resetError }) => (
                <AppErrorFallback resetError={resetError} />
              )}
            >
              <RouterProvider router={router} />
            </Sentry.ErrorBoundary>
            <Toaster />
            <TenkoToaster />
          </TenkoTooltipProvider>
        </TooltipProvider>
      </MotionConfig>
    </div>
  );
}
